import { alpha } from "@mui/system";

const styles = (theme) => ({
  paperContainer: {
    width: "100",
    display: "flex",
    flexDirection: "column",
    borderRadius: "16px",
  },
  boxTitle: {
    width: "100%",
    mb: "15px",
  },
  title: { fontWeight: "bold", fontSize: "20px" },
  paperConfig: {
    padding: "20px",
    borderRadius: "16px",
    backgroundColor: theme.palette.background.wallpaper,
  },
  description: {
    fontWeight: "bold",
    fontSize: "12px",
  },
  containerHeader: {
    p: 1,
  },
  progress: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    zIndex: 2,
    height: 2,
  },
  boxProgress: {
    position: "relative",
    width: "100%",
  },
  chip: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.white.main,
    fontWeight: "bold",
  },
  containerButtons: {
    width: "100%",
    display: "flex",
    justifyContent: "end",
    mt: "20px",
  },
});

export default styles;
